import { Navigate } from "react-router-dom";
import { useAuth } from "../app/store";

export default function RoleRoute({ allowedRoles, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  const roleId = Number(user.role_id);
  if (!allowedRoles.includes(roleId))
    return <Navigate to="/" replace />;

  return children;
}





// import { Navigate } from "react-router-dom";

// export default function RoleRoute({ allowedRoles, children }) {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   const roleId = Number(user.role_id); // 🔥 FIX

//   if (!allowedRoles.includes(roleId)) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }
